module.exports = __webpack_public_path__ + "static/img/264_TO8_2347_og.4ee3caa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/264_TO8_2347_og.jpg
// module id = Qa5e
// module chunks = 0